/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { t } from '../../translations/i18n';
import { getProjectionIdName } from './projection-utils';
import mikeSharedTheme from '../../shared/styles/mikeSharedTheme';

type WorkspaceRecentProjectionsListProps = {
  // TODO masm: define model
  recentProjections: any;
  handleDefaultSelect: (code: string) => void;
};

const RecentProjectionStyle = css`
  color: ${mikeSharedTheme.palette.secondary.main};
  cursor: pointer;
`;

const RecentProjectionListStyle = css`
  padding-top: ${mikeSharedTheme.spacing(2)};
`;

/**
 * @name MmgWorkspaceRecentProjectionList
 * @summary Render a list of epsg codes plus projection name and with a custom callback for selection
 *
 * @param props
 */
const MmgWorkspaceRecentProjectionList = (props: WorkspaceRecentProjectionsListProps) => {
  const { recentProjections, handleDefaultSelect } = props;

  const handleSelection = (code: string) => {
    handleDefaultSelect(code);
  };
  return (
    recentProjections &&
    recentProjections.length > 0 && (
      <>
        <section css={RecentProjectionListStyle}>
          <p>{t('WORKSPACE_PROJECTIONS_RECENT_HELP')}</p>
          {recentProjections.map((entry: any, index: number) => {
            return (
              <div
                css={RecentProjectionStyle}
                key={index}
                onClick={() => {
                  handleSelection(entry.id);
                }}
              >
                {`${getProjectionIdName(entry.id)}   (${entry.name})`}
              </div>
            );
          })}
        </section>
      </>
    )
  );
};

export default MmgWorkspaceRecentProjectionList;
